import { render } from "./FormButtonOk.vue?vue&type=template&id=c7002516"
import script from "./FormButtonOk.vue?vue&type=script&lang=js"
export * from "./FormButtonOk.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__